// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"ConfettiField_hideOnMobile__Y+ANI"};